import { render, staticRenderFns } from "./cancel_account.vue?vue&type=template&id=22656746&scoped=true"
import script from "./cancel_account.vue?vue&type=script&lang=js"
export * from "./cancel_account.vue?vue&type=script&lang=js"
import style0 from "./cancel_account.vue?vue&type=style&index=0&id=22656746&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22656746",
  null
  
)

export default component.exports